<template>
  <section class="Page">
    <Header class="Page__header" :showServiceMenu="false" />
    <div class="Page__inner">
      <img
        src="@spectee/assets/images/img_notFound.png"
        alt=""
        width="240"
        height="240"
      />
      <Heading
        class="Page__heading"
        heading="ご指定のページが見つかりませんでした"
        type="tertiary"
        level="2"
      />
      <p class="Page__text">
        指定されたページにアクセスできませんでした。<br />
        ページが削除、または移動した可能性があります。
      </p>
      <div class="Page__button">
        <Button
          tag="router-link"
          :to="homeUrl"
          dynamics="primary"
          label="ホームへ戻る"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@spectee/components/Atoms/Button/index.vue';
import Heading from '@spectee/components/Atoms/Heading/index.vue';
import Header from '@spectee/components/Organisms/Header/index.vue';

export default {
  name: 'ErrorIndex',
  components: {
    Button,
    Header,
    Heading,
  },
  data() {
    return {
      homeUrl: '/', // 使用サービスによってホームは異なる
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.Page {
  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: $service-unit * 27;
  }

  & &__heading,
  &__text,
  &__button {
    margin-top: $service-unit * 6;
  }

  &__text {
    font-size: $service-font-size-p;
    line-height: $service-line-height-mf;
  }
}
</style>
